import React from "react";

export default function TextToPdf() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Convert .txt to PDF</h2>
      <p>This tool will be implemented here. File conversion logic will run in the browser.</p>
    </div>
  );
}
